import React from "react";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles({
  Fertility: {
    height: 40,
    "& .MuiSelect-select": {
      zIndex: "99",
      fontSize: "14px",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#E6E6E6",
      backgroundColor: "#FFFFFF",
      borderRadius: "10px",
    },
    "& .MuiSelect-icon": {
      zIndex: "99",
    },
    "& .MuiButtonBase-root-MuiMenuItem-root": {
      WebkitAlignItems:'normal',
      alignItems: 'normal',
      backgroundColor:'red'
    },
    },
  });
function SelectMenuItem(props) {
  const { styles, option,name, value, handleChange,label ,submit,placeholder} = props;
  const classes = useStyles();
// console.log(props);
  
  return (
    <FormControl className={styles}>
      <span className="det-label">
        {label}
      </span>
      <Select
        value={value}
        onChange={handleChange}
        name={name}
        displayEmpty
        style={{border: !value && submit ? "1px solid red" : ""}}
        inputProps={{ "aria-label": "Without label" }}
        className={styles === "select-custom" ?  styles : classes.Fertility}
        placeholder={placeholder}
      >
        {option.map((a, i) => (
          <MenuItem value={a.value} key={i}>
            <span>
            {a.icon}&nbsp;
              {a.label}</span>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

export default React.memo(SelectMenuItem);
